import React from 'react';
import SEO from '../components/SEO';

import { useTranslation } from '../hooks/useTranslation';

const TermsOfService = () => {
  const { isBrazil } = useTranslation();
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title={isBrazil ? "Termos de Serviço" : "Terms of Service"}
        description={isBrazil ? "Termos e condições para o uso da plataforma PlataPost." : "Terms and conditions for using the PlataPost platform."}
      />

      <div className="max-w-4xl mx-auto px-6 py-12 glass-card rounded-[3rem] border border-white/5 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/5 blur-[80px] -mr-32 -mt-32" />
        <h1 className="text-4xl lg:text-5xl font-black text-white mb-8 tracking-tighter leading-tight">{isBrazil ? "Termos de Serviço" : "Terms of Service"}</h1>
        
        <p className="text-indigo-500 font-black uppercase tracking-widest text-[10px] mb-12">{isBrazil ? "Última Atualização: 2 de Maio de 2026" : "Last Updated: May 1, 2026"}</p>

        <div className="space-y-12 text-gray-400 font-medium leading-relaxed">
          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">{isBrazil ? "1. Aceitação dos Termos" : "1. Acceptance of Terms"}</h2>
            <p>
              {isBrazil ? "Ao acessar ou usar a plataforma PlataPost, você concorda em cumprir estes Termos de Serviço." : "By accessing or using the PlataPost platform, you agree to be bound by these Terms of Service and all applicable laws and regulations."}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">2. Use of Service</h2>
            <p>
              PlataPost provides AI-powered social media content generation and management tools. You are responsible for any content generated and posted through our platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">3. User Content</h2>
            <p>
              You retain all rights to the content you generate using PlataPost. However, you grant us a license to process your data for the purpose of helping you create that content.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">4. Prohibited Conduct</h2>
            <p>
              You agree not to use the service for any unlawful purposes or to generate content that is harmful, offensive, or violates third-party rights.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">5. Limitation of Liability</h2>
            <p>
              PlataPost is provided "as is." We shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">6. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Your continued use of the service after such changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-black text-white mb-4 tracking-tight">7. Termination</h2>
            <p>
              We may terminate or suspend your account at any time for violation of these terms or for any other reason we deem necessary.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
